import AvatarPlaceholder from './AvatarPlaceholder';
import AvatarPlaceholderNewUserAvatar from '../AvatarPlaceholder.new_user_avatar';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({
    new_user_avatar: AvatarPlaceholderNewUserAvatar,
})(AvatarPlaceholder);
//# sourceMappingURL=index.js.map